import { useEffect, useState } from "react";
import { Loader2, Phone, MapPin, Wallet, Users, PawPrint, Euro, FileText } from "lucide-react";
import { api, fmtDate, waLink } from "@/lib/api";
import { WhatsAppIcon } from "@/components/WhatsAppFloat";

const Chip = ({ icon: Icon, children }) => (
  <span className="flex items-center gap-1.5 rounded-full border border-gold/20 bg-ink/60 px-3 py-1.5 text-xs text-ivory/85">
    {Icon && <Icon size={12} className="text-gold-subtle" />} {children}
  </span>
);

const ProfilesTab = () => {
  const [profiles, setProfiles] = useState(null);

  useEffect(() => {
    api
      .get("/admin/profiles")
      .then((r) => setProfiles(r.data))
      .catch(() => setProfiles([]));
  }, []);

  return (
    <div>
      <h2 className="font-serif text-2xl text-ivory">Fichas «Busca tu piso»</h2>
      {profiles === null && (
        <div className="mt-10 flex justify-center">
          <Loader2 className="animate-spin text-gold" size={28} />
        </div>
      )}
      {profiles && profiles.length === 0 && (
        <p className="mt-10 rounded-xl border border-gold/15 bg-ink2/60 p-8 text-center text-stone2" data-testid="admin-profiles-empty">
          Todavía no hay fichas. Cuando un cliente rellene tu enlace de «Busca tu piso», aparecerá aquí con toda su información.
        </p>
      )}
      <div className="mt-6 space-y-4">
        {profiles &&
          profiles.map((p) => (
            <div key={p.id} data-testid={`profile-card-${p.id}`} className="rounded-xl border border-gold/15 bg-ink2/70 p-5">
              <div className="flex flex-wrap items-center justify-between gap-3">
                <p className="font-medium text-ivory">
                  {p.name} <span className="text-xs text-stone2">· {fmtDate(p.created_at)}</span>
                </p>
                <div className="flex gap-2">
                  <a href={`tel:${p.phone}`} data-testid={`profile-phone-${p.id}`} className="flex items-center gap-1.5 rounded-full border border-gold/25 px-3.5 py-1.5 text-xs text-gold hover:bg-gold/10">
                    <Phone size={12} /> {p.phone}
                  </a>
                  <a
                    href={waLink(`Hola ${p.name.split(" ")[0]}, soy Inmobiliaria Tecnohogar. Recibí tu ficha de «Busca tu piso» y ya tengo opciones para ti.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`profile-whatsapp-${p.id}`}
                    className="flex items-center gap-1.5 rounded-full bg-wa/15 px-3.5 py-1.5 text-xs text-wa hover:bg-wa/25"
                  >
                    <WhatsAppIcon className="h-3.5 w-3.5" /> Responder
                  </a>
                </div>
              </div>
              <div className="mt-3 flex flex-wrap gap-2">
                <Chip icon={FileText}>{p.buscando}</Chip>
                {p.zonas && <Chip icon={MapPin}>{p.zonas}</Chip>}
                {p.presupuesto && <Chip icon={Wallet}>{p.presupuesto}</Chip>}
                <Chip icon={Users}>{p.personas} {p.personas === "1" ? "persona" : "personas"}</Chip>
                <Chip icon={PawPrint}>{p.mascotas}</Chip>
                <Chip icon={Euro}>Cobra: {p.ingresos}</Chip>
                <Chip icon={Wallet}>Ahorra: {p.ahorros}</Chip>
                <Chip icon={FileText}>ASNEF: {p.asnef}</Chip>
              </div>
              {p.notas && <p className="mt-3 whitespace-pre-line rounded-lg bg-ink/60 p-4 text-sm leading-relaxed text-ivory/85">{p.notas}</p>}
            </div>
          ))}
      </div>
    </div>
  );
};

export default ProfilesTab;
